import api from '@utils/api';

export const uploadAvatar = async (file, userId) => {

  
  const formData = new FormData();
  formData.append('avatar', file);
  formData.append('user_id', userId);
  

  for (let [key, value] of formData.entries()) {
    console.log(`FormData - ${key}:`, value);
  }
  
  const response = await api.post('/users/upload-avatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data; 
};